import password from './password';
import interfaceSchema from './interface';

export default {
	password,
	interface: interfaceSchema,
};
